import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.assign.js";
var _excluded = ["className", "height", "duration", "children", "delay", "easing", "onAnimationStart", "onAnimationEnd", "applyInlineTransitions", "animateOpacity"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import AnimateHeight from 'react-animate-height';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
var Collapsible = function Collapsible(_ref) {
  var className = _ref.className,
    height = _ref.height,
    duration = _ref.duration,
    children = _ref.children,
    delay = _ref.delay,
    easing = _ref.easing,
    onAnimationStart = _ref.onAnimationStart,
    onAnimationEnd = _ref.onAnimationEnd,
    applyInlineTransitions = _ref.applyInlineTransitions,
    animateOpacity = _ref.animateOpacity,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    defaultHeight = _useState2[0],
    setDefaultHeight = _useState2[1];
  useEffect(function () {
    if (!height && defaultHeight === 0) {
      setDefaultHeight('auto');
    }
  }, [height]);
  return /*#__PURE__*/React.createElement(AnimateHeight, _extends({
    className: classNames('wds-c-collapsible', className),
    height: height !== null ? height : defaultHeight,
    duration: duration,
    delay: delay,
    easing: easing,
    onAnimationStart: onAnimationStart,
    onAnimationEnd: onAnimationEnd,
    applyInlineTransitions: applyInlineTransitions,
    animateOpacity: animateOpacity,
    animationStateClasses: {
      static: 'wds-c-collapsible--static',
      staticHeightZero: 'wds-c-collapsible--height-zero',
      staticHeightAuto: 'wds-c-collapsible--height-auto',
      staticHeightSpecific: 'wds-c-collapsible--height-specific',
      animating: 'wds-c-collapsible--animating',
      animatingUp: 'wds-c-collapsible--animating-up',
      animatingDown: 'wds-c-collapsible--animating-down',
      animatingToHeightZero: 'wds-c-collapsible--animating-to-height-zero',
      animatingToHeightAuto: 'wds-c-collapsible--animating-to-height-auto',
      animatingToHeightSpecific: 'wds-c-collapsible--animating-to-height-specific'
    }
  }, otherProps), children);
};
Collapsible.propTypes = {
  /** additional styling - do not apply styles that effect height */
  className: PropTypes.string,
  /** Numeric or percentage value (ie. '50%') or 'auto', required
    When changed, element height will be animated to that height.
    To slide up use 0, for slide down use 'auto'. If no height is provided
    the height will be set to 0 and immediately animated to 'auto' */
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Duration of the animation in milliseconds */
  duration: PropTypes.number,
  /** children of the panel component */
  children: PropTypes.node.isRequired,
  /** Animation delay in milliseconds */
  delay: PropTypes.number,
  /** CSS easing function to be applied to the animation - eg. "ease" | "linear" | "ease-in" | "ease-out" | "ease-in-out" | 'cubic-bezier(…)' */
  easing: PropTypes.string,
  /** Callback which will be called when animation starts. The first argument passed to this callback is an object containing newHeight, the pixel value of the height at which the animation will end. */
  onAnimationStart: PropTypes.func,
  /** Callback which will be called when animation ends. The first argument passed to this callback is an object containing newHeight, the pixel value of the height at which the animation ended. */
  onAnimationEnd: PropTypes.func,
  /** If set to 'false' only CSS classes will be applied to the element and inline transition styles will not be present. */
  applyInlineTransitions: PropTypes.bool,
  /** If set to 'true' content will fade-in (and fade-out) while height is animated. */
  animateOpacity: PropTypes.bool
};
Collapsible.defaultProps = {
  className: undefined,
  height: null,
  duration: 348,
  delay: 0,
  easing: 'cubic-bezier(0.2, 0.2, 0.38, 0.9)',
  onAnimationStart: undefined,
  onAnimationEnd: undefined,
  applyInlineTransitions: true,
  animateOpacity: false
};
export default Collapsible;